import React from "react";
import "./CROWNS_BRIDGES.css";
import Teeth_Whiting_img from "../images/Dental_bridge.jpg";
export default function CROWNS_BRIDGES() {
  return (
    <div className="container_Crown_">
      <h1>CROWNS BRIDGES</h1>
      <div className="img_box_Crown">
        <img src={Teeth_Whiting_img} className="img_of_Crown" alt="" />
      </div>
      <div className="text_main_Crown">
        <p>
          Dental crowns and bridges/extensions are exclusively fitted tooth
          prosthetics that are utilized to replace or re-establish harmed or
          missing teeth. Crowns – otherwise called tops/caps – are settled over
          the surfaces of common tooth structures or dental inserts. Extensions
          are utilized to fill in the holes, securely set up by the teeth or
          crowns closest to the vacant space. Both the crowns and extensions are
          altered particularly for the patient's chewing habits and can be more
          often completed in one or two of dental visits. They are non-removable
          and must be established by an authorized dental surgeon.
        </p>
        <h1>DID YOU KNOW??</h1>
        <p>
          With legitimate cleaning and standard dental inspection, crowns and
          extensions can last numerous years. Patients who get crown or
          extensions to re-establish their grins mostly accomplish both the
          capacity and appearance of teeth. The White dental practitioners are
          sufficiently experienced to expel the contaminated mash, find every
          one of the trenches, close them totally, and legitimately put a dental
          crown on it.
        </p>
        <div className="FAQ_Service_Crown">
          <h2>FAQ'S</h2>
        </div>
      </div>
    </div>
  );
}
